import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import {Box, Button, H3, Paragraph} from '../../styled';
import GtcStore from '../../xstores/gtc';
import useObservable from '../../hooks/useObservable';
import {Spinner} from 'react-bootstrap';
import auth from '../../services/authentication';
import DataTable from './DataTable';
import Stats from './Stats';

const Gtc = () => {
  const dataSetName = useObservable(GtcStore.dataSetName$, 'updated');
  const dataSet = useObservable(GtcStore.dataSet$, []);
  const isLoading = useObservable(GtcStore.loading$, false);

  const runTest = (pl?:string) => () => {
    GtcStore.startTest(pl);
  }
  const chooseDataset = (set:string) => () => {
    GtcStore.setDataSet(set);
  }
  useEffect(() => {
    GtcStore.getUserDataSet();
  }, []);

  if (
    window.location.origin.indexOf('localhost') === -1 &&
    window.location.origin.indexOf('dev.gotrova.ai') === -1 &&
    window.location.origin.indexOf('stage.gotrova.ai') === -1
  ) {
    return <Redirect to={'/'} />;
  }

  return (
    <Box
      padding={4}
    >
      <Box
        display="flex"
        alignItems="flex-start"
      >
        <Box
          width="50%"
        >
          <H3>
            GTC - Ground truth checker
          </H3>
          <Paragraph>
            Current user: {auth.getEmail()}
          </Paragraph>
          <Paragraph>
            We have <strong>{dataSet.filter((set:any) => set.Query).length} queries</strong> for current user
          </Paragraph>

        </Box>

        <Box
          mt={3}
          mb={3}
          width="50%"
        >
          <Box mb={4}>
            <Paragraph>Choose queries dataset</Paragraph>
            <Button
              mr={2}
              disabled
              variant={dataSetName === 'old' ? 'primary' : 'outline-primary'}
              onClick={chooseDataset('old')}
            >
              Evaluator script
            </Button>
            <Button
              mr={2}
              disabled
              variant={dataSetName === 'new' ? 'primary' : 'outline-primary'}
              onClick={chooseDataset('new')}
            >
              Evaluator script new
            </Button>
            <Button
              mr={2}
              variant={dataSetName === 'updated' ? 'primary' : 'outline-primary'}
              onClick={chooseDataset('updated')}
            >
              Latest queries
            </Button>
          </Box>
          <Box>
            <Button
              mr={2}
              onClick={runTest()}
              disabled={isLoading}
            >
              Run test
            </Button>
            {isLoading &&
              <Spinner animation="border" variant="primary" />
            }
          </Box>
        </Box>
      </Box>
      <Stats />
      <DataTable />
    </Box>
  )
}

export default Gtc;